import React, { FC } from 'react'
import cx from 'classnames'
import RCSlider from 'rc-slider'
import 'rc-slider/assets/index.css'
import styles from './Slider.module.scss'

type SliderProps = {
  min?: number
  max?: number
  defaultValue?: number
  value?: number
  marks?: { [key: number]: any }
  step?: number | null
  onChange: (value: number) => void
}

// This component is a proxy for rc-slider
// Docs: https://github.com/react-component/slider/
export const Slider: FC<SliderProps> = ({
  min = 0,
  max = 100,
  marks,
  step = 1,
  onChange,
  defaultValue,
  value,
}) => {
  const classes = cx({
    [styles.slider]: true,
    [styles.hasMarks]: marks,
  })

  return (
    <RCSlider
      min={min}
      max={max}
      marks={marks}
      step={step}
      onChange={onChange}
      defaultValue={defaultValue}
      value={value}
      className={classes}
    />
  )
}

Slider.displayName = 'Slider'
